<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
        <div class="mt-6 flex items-center justify-between px-6">
            <h4>{{ Object.entries(this.data).length === 0 ? "NOUVEAU" : "MODIFIER UN" }} SERVICE</h4>
            <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false, error = []" class="cursor-pointer"/>
        </div>
        <vs-divider class="mb-0" />
        <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
            <div class="px-6 py-2">
                <vs-input label="Service" @keyup.enter="addOrUpdate()"
                          autocomplete="off"
                          :danger="error.name ? true : false"
                          :danger-text="error.name ? error.name[0] : ''"
                          v-model="name" class="mt-5 w-full" name="item-code" />
                <vs-textarea @keyup.enter="addOrUpdate()"
                            :danger="error.description ? true : false"
                             autocomplete="off"
                            :danger-text="error.description ? error.description[0] : ''"
                  label="Description" v-model="description" class="mt-5 w-full" />

            </div>
        </VuePerfectScrollbar>
        <div class="flex flex-wrap items-center p-6" slot="footer">
            <vs-button @click="addOrUpdate()" class="mr-6">Soumettre</vs-button>
            <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false, error = []">Annuler</vs-button>
        </div>
    </vs-sidebar>
</template>

<script>
    import VuePerfectScrollbar from 'vue-perfect-scrollbar';
    export default {
        components: {VuePerfectScrollbar},
        props: {
            isSidebarActive: {
                type: Boolean,
                required: true
            },
            data: {
                type: Object,
                default: () => {},
            },
            loadService:{
                type: Function,
                required: true
            }
        },
        data() {
            return {
                id: null,
                name: '',
                description: 1,
                settings: { // perfectscrollbar settings
                    maxScrollbarLength: 60,
                    wheelSpeed: .60,
                },
                error: []
            }
        },
        computed: {
            isSidebarActiveLocal: {
                get() {
                    return this.isSidebarActive
                },
                set(val) {
                    if(!val) {
                        this.$emit('closeSidebar')
                    }
                }
            },
        },
        methods: {
            initValues() {
                if(this.data.id) return;
                this.id = null;
                this.name = '';
                this.description = '';
            },
            addOrUpdate(){
                this.error = []
                if (this.id !== null){
                  this.$vs.loading()
                  this.$http.post('/services/update/'+this.id, {
                    name: this.name,
                    description: this.description
                  }).then((response) => {
                    if (response.data.status){
                      this.$vs.loading.close()
                      this.isSidebarActiveLocal = false
                      this.loadService()
                      window.GETCCMT.notification('success','Success','Opération effectuée');
                    }else {
                      this.$vs.loading.close()
                      window.GETCCMT.notification('error','Echec','Une erreur est survenu');
                    }
                  }).catch((error) =>{
                    this.$vs.loading.close()
                    if (error.response.status === 401){
                      this.$router.push('/login')
                    }else this.error = error.response.data.errors
                  })
                }else {
                  this.$vs.loading()
                  this.$http.post('/services/create',{
                    name: this.name,
                    description: this.description
                  }).then((response) => {
                    if (response.data.status){
                      this.$vs.loading.close()
                      this.isSidebarActiveLocal = false
                      this.loadService()
                      window.GETCCMT.notification('success','Success','Opération effectuée');
                    }else {
                      this.$vs.loading.close()
                      window.GETCCMT.notification('error','Echec','Une erreur est survenu');
                    }
                  }).catch((error) =>{
                    this.$vs.loading.close()
                    if (error.response.status === 401){
                      this.$router.push('/login')
                    }else this.error = error.response.data.errors
                  })
                }
            },
        },
        watch: {
            isSidebarActive(val) {
                if(!val) return;
                if(Object.entries(this.data).length === 0) {
                    this.initValues()
                } else {
                    let { id, name, description } = JSON.parse(JSON.stringify(this.data));
                    this.id = id;
                    this.description = description;
                    this.name = name;
                    this.initValues();
                }

            }
        }

    }
</script>

<style lang="scss" scoped>
    .add-new-data-sidebar {
        ::v-deep .vs-sidebar--background {
            z-index: 52010;
        }

        ::v-deep .vs-sidebar {
            z-index: 52010;
            width: 400px;
            max-width: 90vw;

            .img-upload {
                margin-top: 2rem;

                .con-img-upload {
                    padding: 0;
                }

                .con-input-upload {
                    width: 100%;
                    margin: 0;
                }
            }
        }
    }

    .scroll-area--data-list-add-new {
        // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
        height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
    }
</style>
